"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "addOptions", {
    enumerable: true,
    get: function() {
        return addOptions;
    }
});
const _options = require("./options.js");
function addOptions(category, command) {
    for (const option of Object.values(_options.options[category])){
        command.addOption(option);
    }
    return command;
}
